import React from 'react';

const Impressum = () => {
  return (
    <div className="container mx-auto px-6 lg:px-12 py-20 min-h-[50vh]">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-slate-900 mb-6">Impressum</h1>
        <div className="w-16 h-1 bg-red-800 rounded-full mb-10"></div>
        
        <div className="space-y-8 text-slate-700 leading-relaxed">
          <section>
            <p className="text-lg">
              Kittsteiner Hoch-Tiefbau GmbH<br />
              Bachstraße 7<br />
              91785 Pleinfeld
            </p>
          </section>

          <section>
            <p className="font-bold text-slate-900 mb-1">Vertreten durch:</p>
            <p>Felix Kittsteiner</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Kontakt</h2>
            <p>
              Telefon: 015174465832<br />
              E-Mail: <a href="mailto:info@kittsteiner-bau.de" className="text-red-800 hover:underline">info@kittsteiner-bau.de</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
            <p className="mb-2">
              <span className="font-bold">Berufsbezeichnung:</span><br />
              Maurermeister
            </p>
            <p>
              <span className="font-bold">Verliehen in:</span><br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
            <p>
              Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil. 
              Zuständig ist die Universalschlichtungsstelle des Zentrums für Schlichtung e.V., 
              Straßburger Straße 8, 77694 Kehl am Rhein (
              <a href="https://www.verbraucher-schlichter.de" rel="noopener noreferrer" target="_blank" className="text-red-800 hover:underline">
                https://www.verbraucher-schlichter.de
              </a>).
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;